import { Fragment, useEffect } from 'react'

import { checkCookies, getCookie, removeCookies } from 'cookies-next'
import {
  SendAdditionalEmailConfirmation,
  SendAdditionalEmailConfirmationVariables,
} from 'globalTypes'

import { useMutation } from '@apollo/client'
import { getCookieDomain } from 'lib/domain'
import { useCurrentUserId } from 'lib/use-current-user-id'
import first from 'lodash/first'
import isArray from 'lodash/isArray'

import MUTATION from './send-additional-email-confirmation.graphql'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const AdditionalEmailConfirmation = ({ children }: Props) => {
  const userId = useCurrentUserId()
  const [mutate] = useMutation<
    SendAdditionalEmailConfirmation,
    SendAdditionalEmailConfirmationVariables
  >(MUTATION)

  useEffect(() => {
    if (!Boolean(userId)) {
      return
    }

    if (checkCookies('additional_email_to_confirm')) {
      // if there's an additional email to confirm
      const rawSha1 = getCookie('additional_email_to_confirm')
      const sha1 = isArray(rawSha1) ? first(rawSha1) : rawSha1
      // we send the request to the server
      mutate({
        variables: {
          sha1,
        },
      })
        .then(() => {
          // remove the cookie
          removeCookies('additional_email_to_confirm', {
            domain: getCookieDomain(window.location.hostname),
          })

          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => console.log('[ERROR]: ', error))
    }
  }, [mutate, userId])

  return <Fragment>{children}</Fragment>
}

export default AdditionalEmailConfirmation
